import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { deletePatientUploadedFiles, setAndrologyData, setPatientUploadedFiles } from '../../../../actions/andrologyAction';
import { getNestedState } from '../utils/index';
import { normalValues } from '../../../../constants/normalValues';
import { renderDropdownWithoutLabel } from '../../../../common/inputField';
import FileUploadCard from '../../../../components/FileManager/FileUploadCard';
import { updateFileStatusUploaded, uploadPatientFileApi } from '../../../../api/patientApi';
import { toast } from 'sonner';
import FileDocumentCard from '../../../../components/FileManager/FileDocumentCard';
import { deleteFileApi } from '../../../../api/fileApi';

const DfiDetails = ({ keyPath,handleUpdate }) => {
  const dispatch = useDispatch();
  const dfiData = useSelector((state) => getNestedState(state.andrologyReducer, keyPath));
  const selectedPatientData = useSelector((state) => state.andrologyReducer.selectedPatientData);

  const dfi = useSelector((state) => state.andrologyReducer.dfi);

  const uploadedFiles = useSelector((state) => state.andrologyReducer.selectedPatientData.patientFiles);
  const handleChange = (key,value) => {
    dispatch(setAndrologyData(`${keyPath}.${key}`, value));
  };


  const handleDropdownChange = (e, index, name) => {
    const { value } = e.target;
    handleChange(name, value);
  };

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const setUploadedFiles = (files) => {
    dispatch(setPatientUploadedFiles(files));
  };


  const fileTagDFI =  `DFI-${dfi.id}`
  const handleUpload = async (file, patientId) => {

    if (fileTagDFI === 'DFI-undefined') return toast.error('Failed to upload file');
    if (!patientId) return toast.error('Patient not created');

    return new Promise((resolve, reject) => {
      try {
        setLoading(true);
     
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            fileTagDFI,
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
      
              setUploadedFiles( {fileTag: fileTagDFI, file:data});
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 800,
          },
        );
      } catch (err) {
        setLoading(false);
        toast.error('Failed to upload file');
      }
    });
  };

  const handleDeleteFile = async (file) => {
    try {

      await deleteFileApi('patient', selectedPatientData.patient.id, file.id);
      dispatch(deletePatientUploadedFiles(file));
      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };

  return (
    <Box flex={1}>
      <Paper className="p-3 mb-3">
        <Typography variant="h6" gutterBottom>
          Sperm DNA Fragmentation Index (DFI)
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>Parameter</TableCell>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>Value</TableCell>
                <TableCell style={{ width: '200px', fontWeight: 'bold' }}>WHO Normal Values</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Sperm DNA Fragmentation Index (DFI)</TableCell>
                <TableCell>
                  <TextField
                  type="number"
                  onWheel={(e) => e.target.blur()}
                    value={dfiData.dnaFregmentationIndex}
                    onChange={(e) => handleChange('dnaFregmentationIndex',e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    className="normal-value"
                    disabled
                    value={normalValues.dnaFregmentationIndex}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>DFI Images to be added</TableCell>
                <TableCell>
                {
                    renderDropdownWithoutLabel('dfiImagesToBeAttached', dfiData.dfiImagesToBeAttached ? dfiData.dfiImagesToBeAttached : 'No',['Yes', 'No'], handleDropdownChange)
                  }
                </TableCell>
                  
              </TableRow>

            </TableBody>
          </Table>
        </TableContainer>

        { dfiData.dfiImagesToBeAttached === 'Yes' && 
              <div style={{marginTop: 20}}>
                <div className="row clearfix">
                  <FileUploadCard
                    setFiles={setFiles}
                    setUploadedFiles={setUploadedFiles}
                    files={uploadedFiles}
                    handleUpload={handleUpload}
                    id={selectedPatientData.patient.id}
                    fileSelectionType="image/*"
                    disabled={uploadedFiles.filter(uploadFile => uploadFile.fileTag === "DFI").length > 3}
                  />
                  {uploadedFiles.map((uploadedFile, i) => {
                     const data = uploadedFile.file;
                    if (uploadedFile.fileTag !== fileTagDFI) return null;
                    return (
                      <FileDocumentCard
                        key={i}
                        DocumentName={data.displayFileName}
                        DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                        DocumentDate={new Date(
                          data.updatedAt,
                        ).toLocaleDateString()}
                        ImageUrl={
                          data?.fileType?.includes('image')
                            ? data.presignedUrl
                            : undefined
                        }
                        handleDeleteFile={() => handleDeleteFile(data)}
                        file={data}
                        fileUniquePrefix={`patient-${selectedPatientData.patient.id}`}
                      />
                    );
                  })}
                </div>
              </div>}
      </Paper>
    </Box>
  );
};

export default DfiDetails;
